import React from 'react';
import AdSense from 'react-adsense';

export default (props) => {
	const adClient = "ca-pub-7968086371323995";
	let dataAdSlot = "8485274383";
	if (props.dataAdSlot) {
		dataAdSlot = props.dataAdSlot;
	}

	return (
		<AdSense.Google
			client={adClient}
			slot={dataAdSlot}
			style={{display:"block"}}
			format="auto"
			responsive="true"
		/>
       );
};



// WEBPACK FOOTER //
// ./src/c/OurAdSense.js